import type { ChangeEvent, ReactNode } from 'react';

import { Dialog } from '@mui/material';

import ShareDialogContent from '@/pages/Markets/MarketsComponents/Share/ShareDialogContent';

const ShareDialog = ({
  open,
  onClose,
  content,
  emailError,
  handleChangeRecipient,
  header,
  recipient,
  shareUrl,
  onContentChange,
  onCopyClick,
  onSendEmail,
  enableSendEmail = true,
  renderLinkSection
}: {
  open: boolean;
  onClose: () => void;
  content: string;
  emailError: string;
  handleChangeRecipient: (recipient: string) => void;
  header: ReactNode;
  recipient: string;
  shareUrl: string;
  onContentChange: (content: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onCopyClick?: () => void;
  onSendEmail: () => void;
  enableSendEmail?: boolean;
  renderLinkSection?: ReactNode;
}) => {
  return (
    <Dialog
      open={open}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(2px)',
            backgroundColor: 'rgba(18, 22, 63, 0.80)'
          }
        }
      }}
      sx={{
        zIndex: 99999
      }}
      onClose={onClose}
    >
      <ShareDialogContent
        content={content}
        emailError={emailError}
        enableSendEmail={enableSendEmail}
        handleChangeRecipient={e => {
          handleChangeRecipient(e.target.value);
        }}
        header={header}
        recipient={recipient}
        renderLinkSection={renderLinkSection}
        shareUrl={shareUrl}
        onContentChange={onContentChange}
        {...(onCopyClick && { onCopyClick })}
        onSendEmail={onSendEmail}
      />
    </Dialog>
  );
};

export default ShareDialog;
